import React from 'react';

const LowStockItem = ({ item }) => {
  const stockPercentage = (item.quantity / item.minstock) * 100;
  const stockColor = stockPercentage < 20 ? 'text-red-600' : 'text-yellow-600';
  const barColor = stockPercentage < 20 ? 'bg-red-500' : 'bg-yellow-500';

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
      <div className="flex justify-between items-start mb-3">
        <div>
          <h4 className="font-semibold text-gray-900">{item.name}</h4>
          <p className="text-xs text-gray-500 mt-1">SKU: {item.sku}</p>
        </div>
        <span className={`text-sm font-bold ${stockColor}`}>
          {item.quantity} / {item.minstock}
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div className={`${barColor} h-2 rounded-full`} style={{ width: `${Math.min(stockPercentage, 100)}%` }}></div>
      </div>
      <p className="text-xs text-gray-500 mt-2">Reorder quantity: {item.reorderqty}</p>
    </div>
  );
};

export default LowStockItem;
